﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import Select from "react-select";

import { hasPermission, toast, validRoles } from "@/services/Utils";
import Fetching from "@/components/Fetching/Fetching";
import { useOrderClassification } from "@/hooks/maintainers/order_classifications";

import { base_element } from "../order_classifications.constants";
import classes from "../../maintainers.module.scss";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const OrderClassificationsForm = ({ confirmSave, isLoadingSave, customers, permissions }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, classification_id } = useParams();
	const navigate = useNavigate();

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const [data, setData] = useState({ ...base_element });

	const { data: response, isLoading } = useOrderClassification(classification_id);

	useEffect(() => {
		if (response) {
			setData(response.detail);
		}
	}, [response]);

	const handleClose = () => {
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate("/configuracion/clasificaciones_oc");
	};

	const validSave = () => {
		if (!data.name) {
			toast(addToast, "Debe ingresar un nombre para guardar.", "error");
			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			confirmSave(data);
		}
	};

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Clasificación OC</h4>
			</Modal.Header>

			<Modal.Body>
				{isLoading || isLoadingSave ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre</Form.Label>
								<Form.Control
									value={data ? data.name : ""}
									onChange={(e) =>
										setData({
											...data,
											name: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>

						{isAdmin && (
							<Col md={12} xs={12}>
								<Form.Group className={classes.group_form}>
									<Form.Label className={classes.label}>Cliente</Form.Label>
									<Select
										value={customers && customers.filter((c) => Number(c.value) === Number(data.customer_id))}
										placeholder={<div>Seleccione</div>}
										options={customers ? customers : []}
										onChange={(value) => {
											let newData = { ...data };
											newData.customer_id = value ? value.value : "";
											setData(newData);
										}}
										components={{
											NoOptionsMessage,
										}}
										isClearable
									/>
								</Form.Group>
							</Col>
						)}
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{(classification_id ? hasPermission("edit", permissions) : hasPermission("create", permissions)) && !isLoading && (
					<Button variant="success" onClick={handleSave} disabled={isLoading || (isLoadingSave && true)}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default OrderClassificationsForm;
